/**
 * External Imports
 */
import styled from 'styled-components';

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 20em;
`;

export const SelectContainer = styled.div`
  width: 100%;
`;
